import styled from "styled-components";

export const PoHistoryWrapper = styled.div`
  .box-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 10px;
    margin-bottom: 16px;
  }

  .sku-box {
    padding: 8px 14px;
    min-width: 120px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.15s ease;
    &.active-box {
      box-shadow: 0 0 0 2px currentColor;
    }
    h4 {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 0;
      line-height: 1.2;
      color: inherit;
    }
    p {
      color: #6B7280;
      font-size: 10px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      margin-bottom: 2px;
    }
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
    &.box-purple {
      background: rgba(104, 72, 186, 0.06);
      border: 1px solid rgba(104, 72, 186, 0.2);
      color: #6848BA;
    }
    &.box-orange {
      background: rgba(255, 153, 0, 0.06);
      border: 1px solid rgba(255, 153, 0, 0.2);
      color: #FF9900;
    }
    &.box-blue {
      background: rgba(21, 101, 216, 0.06);
      border: 1px solid rgba(21, 101, 216, 0.2);
      color: #1565D8;
    }
    &.box-green {
      background: rgba(0, 156, 52, 0.06);
      border: 1px solid rgba(0, 156, 52, 0.2);
      color: #009C34;
    }
    &.box-cyan {
      background: rgba(71, 181, 255, 0.06);
      border: 1px solid rgba(71, 181, 255, 0.2);
      color: #47B5FF;
    }
    &.box-violet {
      background: rgba(151, 71, 255, 0.06);
      border: 1px solid rgba(151, 71, 255, 0.2);
      color: #9747FF;
    }
    &.box-red {
      background: rgba(217, 80, 64, 0.06);
      border: 1px solid rgba(217, 80, 64, 0.2);
      color: #D95040;
    }
  }

  .po-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 16px;

    .toolbar-left {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
    }

    .toolbar-title {
      font-size: 18px;
      font-weight: 700;
      color: #1B2559;
      margin: 0;
    }

    .toolbar-count {
      background: rgba(21, 101, 216, 0.08);
      color: #1565D8;
      font-size: 12px;
      font-weight: 600;
      padding: 2px 10px;
      border-radius: 12px;
      line-height: 1.4;
    }

    .toolbar-right {
      display: flex;
      align-items: center;
      gap: 10px;
      .toolbar-search {
        margin-bottom: 0;
        input.form-control {
          height: 32px;
          padding-top: 4px;
          padding-bottom: 4px;
        }
        .form-group {
          margin-bottom: 0;
        }
      }
      .select2-container {
        margin-bottom: 0 !important;
      }
    }
  }

  .po-status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    &.badge-pending { background: rgba(255, 153, 0, 0.1); color: #FF9900; }
    &.badge-confirmed { background: rgba(21, 101, 216, 0.08); color: #1565D8; }
    &.badge-arrived { background: rgba(0, 156, 52, 0.08); color: #009C34; }
    &.badge-receiving { background: rgba(71, 181, 255, 0.1); color: #2196F3; }
    &.badge-processed { background: rgba(151, 71, 255, 0.08); color: #9747FF; }
    &.badge-deleted { background: rgba(217, 80, 64, 0.08); color: #D95040; }
  }

  .ag-center-aligned-header {
    .ag-header-cell-label {
      justify-content: center;
    }
  }

  .delete-icon {
    color: ${({ theme }) => theme['danger-hover']};
    font-size: 16px;
    cursor: pointer;
    margin-left: 10px;
  }

  .crate-po-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: baseline;
    grid-gap: 16px;
  }
`;

export const ModalWrapper = styled.div`
  .delete-modal-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
`;
